var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import moment from 'moment';

import { DatePicker } from '../date/DatePicker';

import { fieldValue } from 'sdc-data-models';

var EntryDate = inject('store')(observer(function (_ref) {
  var field = _ref.field,
      store = _ref.store,
      props = _objectWithoutProperties(_ref, ['field', 'store']);

  if (field.dataType !== 'date') {
    return null;
  }

  var value = fieldValue(store._sending, field.key);
  if (!field.editable) {
    return value ? moment(value).format(field.display || 'DD.MM.YYYY') : null;
  }

  var current = moment(value || new Date()).toDate();
  console.log('EntryDate', value, current);

  var handleChange = function handleChange(value) {
    var date = moment(value || new Date()).toISOString();
    console.log('handleChange()', value, date);
    store.updateFieldWith(field, {}, date, true);
  };

  return React.createElement(DatePicker, _extends({ format: field.display || 'DD.MM.YYYY',
    value: current || new Date(), includeTime: true,
    onFocus: store.selectField(field),
    onChange: handleChange
  }, props));
}));
export { EntryDate };